<template>
  <el-row class="mt-9">
    <el-col
      :span="6"
      :offset="9"
    >
      <el-card
        header="Teams"
        shadow="never"
      >
        <TeamSwitcherTeamsList
          v-model="team"
          class="p-3 mb-4"
        />

        <div class="text-right pr-3 mb-1">
          <el-button
            :disabled="isSwitchingTeam"
            size="small"
          >
            Cancel
          </el-button>

          <el-button
            type="primary"
            size="small"
            :loading="isSwitchingTeam"
            @click.native="switchTeam"
          >
            Switch
          </el-button>
        </div>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import TeamSwitcherTeamsList from '@/components/TeamSwitcher/TeamsList'
/**
 * The v2 [shipper] application handover view.
 */
export default {
  components: {
    TeamSwitcherTeamsList
  },
  data () {
    return {
      isSwitchingTeam: false,
      team: undefined
    }
  },
  methods: {
    async switchTeam () {
      this.isSwitchingTeam = true

      if (typeof this.team !== 'undefined' && this.team !== (await this.$session.instance).team.id) {
        await this.$session.switchTeam(this.team)
        this.$router.push({ name: 'application' })
      }

      this.isSwitchingTeam = false
    }
  }
}
</script>
